import { Chip, Divider, Paper } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import DOMPurify from 'dompurify'
import { saveAs } from 'file-saver'
import { Buffer } from 'buffer'

function EmailBody({ selectedItem }) {
  const emailHtml = selectedItem.html
  if (emailHtml === '0' || emailHtml === null)
    return (
      <Box sx={{ height: '100%', width: '100%', padding: '2%', overflowY: 'auto', display: 'flex' }}>
        <Typography sx={{ whiteSpace: 'pre' }}>{selectedItem.text}</Typography>
      </Box>
    )
  else
    return (
      <Box sx={{ height: '100%', width: '100%', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Box
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(selectedItem?.html)
          }}
        />
      </Box>
    )
}

const EmailContent = ({ selectedItem }) => {
  const downladfile = (index) => {
    const file = selectedItem.attachments[index].file
    const buffer = Buffer.from(file)
    const blob = new Blob([buffer])

    saveAs(blob, selectedItem.attachments[index].filename)
  }

  return (
    <Paper
      sx={{
        width: '100%',
        margin: '5px',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {selectedItem && (
        <>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              padding: '2%',
              flexDirection: 'row'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                padding: '2%',
                width: '100%',
                flexDirection: 'column'
              }}
            >
              <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'baseline' }}>
                {selectedItem.fromName && (
                  <Typography sx={{ display: 'flex', flexDirection: 'row', marginRight: 1 }}>
                    {selectedItem.fromName}
                  </Typography>
                )}
                <Chip label={selectedItem.fromEmail} />
              </Box>

              <Typography
                sx={{ display: 'flex', flexDirection: 'row' }}
                component='span'
                variant='body2'
                color='text.primary'
              >
                {selectedItem.subject}
              </Typography>

              <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'baseline' }}>
                <Typography sx={{ display: 'flex', flexDirection: 'row', marginRight: 1 }}>A</Typography>
                {selectedItem.toEmail &&
                  selectedItem.toEmail
                    .split(';')
                    .map((add, index) => <Chip key={`A-${index}`} sx={{ marginRight: '5px' }} label={add} />)}
              </Box>

              {selectedItem.ccEmail && (
                <Box sx={{ display: 'flex', marginTop: '2px', flexDirection: 'row' }}>
                  <Typography sx={{ display: 'flex', flexDirection: 'row', marginRight: 1 }}>Copie</Typography>
                  {selectedItem.ccEmail.split(';').map((add, index) => (
                    <Chip key={`CC-${index}`} sx={{ marginRight: '5px' }} label={add} />
                  ))}
                </Box>
              )}

              {selectedItem.attachments?.length > 0 && (
                <Box sx={{ display: 'flex', marginTop: '2px', flexDirection: 'row' }}>
                  <Typography sx={{ display: 'flex', flexDirection: 'row', marginRight: 1 }}>Pièces jointes</Typography>
                  {selectedItem.attachments.map((file, index) => (
                    <Chip
                      onClick={() => downladfile(index)}
                      key={`file-${index}`}
                      sx={{ marginRight: '5px', cursor: 'pointer' }}
                      label={file.filename}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </Box>

          <Divider />

          <EmailBody selectedItem={selectedItem} />
        </>
      )}
    </Paper>
  )
}

export default EmailContent
